import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Image, ImageComponent } from '@teamfoster/sdk/image';
import { DatePipe, NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { Event } from '../../models';
import { RouterLink } from '@angular/router';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { isPast } from 'date-fns';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { IconComponent } from '@teamfoster/sdk/icon';
import { EventDateTimePipe } from '../../pipes/event-date-time.pipe';

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [
    ImageComponent,
    DatePipe,
    YoutubeComponent,
    EventDatePipe,
    RouterLink,
    NgClass,
    NgIf,
    NgOptimizedImage,
    FromDictionaryPipe,
    UrlRewritePipe,
    IconComponent,
    EventDateTimePipe,
  ],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCardComponent {
  event = input.required<Event>();
  inList = input<boolean>(false);
  priority = input<boolean>(false);
  cookiePreferences = input<CookiePreferences>();
  theme = input<'primary' | 'secondary'>('primary');
  hasRecurrencePattern = computed(() => (this.event().eventDates?.length || 0) > 1);

  isPastEvent = computed(() => {
    if (this.event().endDate) {
      return isPast(this.event().endDate!);
    }
    return isPast(this.event().startDate);
  });
}
